var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleClick}},[_vm._t("content",[_c('div',{staticClass:"jrm-sect jrm-flx-grow"},[(_vm.isLoading)?_c('div',{staticClass:"jrm-inline-spinner"}):_vm._t("default")],2)],{"isLoading":_vm.isLoading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }